import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b7339670"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "TProfissional",
  "data-testid": "TProfissional"
}
const _hoisted_2 = {
  class: "TProfissional__Header",
  "data-testid": "TProfissional__Header"
}
const _hoisted_3 = { class: "TProfissional__Action" }

import { OTrilhaDeNavegacao } from "@/components/Gerais"
  import { OTabelaProfissionais } from "../"
  import PButton from "primevue/button"
  import { MenuItem } from "primevue/menuitem"
  import { useI18n } from "vue-i18n"
  import { useRouter } from "vue-router"

  interface Props {
    breadCrumbItems: MenuItem[]
    home: MenuItem
    info: string
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'TProfissional',
  props: {
    breadCrumbItems: null,
    home: null,
    info: null
  },
  setup(__props: any) {

  

  const { t } = useI18n()
  const router = useRouter()


  const redicionarNovoProfissinal = (): void => {
    router.push("/profissionais/novo-profissional")
  }

return (_ctx: any,_cache: any) => {
  const _directive_permissionamento = _resolveDirective("permissionamento")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(OTrilhaDeNavegacao), {
        "data-testid": "TProfissional__Bread",
        descricao: __props.info,
        "inicio-da-trilha": __props.home,
        "itens-da-trilha": __props.breadCrumbItems
      }, null, 8, ["descricao", "inicio-da-trilha", "itens-da-trilha"]),
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createVNode(_unref(PButton), {
          onClick: redicionarNovoProfissinal,
          class: "TProfissional__Button p-button-warning",
          "data-testid": "TProfissional__Button",
          label: _unref(t)('criarProfissional')
        }, null, 8, ["label"]), [
          [_directive_permissionamento, { operacao: 'criar' }, "Profissionais"]
        ])
      ])
    ]),
    _createVNode(_unref(OTabelaProfissionais))
  ]))
}
}

})